<ng-container *ngIf="translations$ | async as translations">
    <p-button
            *ngIf="visible"
            [label]="translations?.clearAll"
            icon="pi pi-times"
            styleClass="p-button-danger m-1"
            (click)="clear.emit()"
    ></p-button>
</ng-container>
